/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wallet_Card_Insured_NameInputs */

const en_wallet_card_insured_name = /** @type {(inputs: Wallet_Card_Insured_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insured Name`)
};

const fr_wallet_card_insured_name = /** @type {(inputs: Wallet_Card_Insured_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom de l'assuré`)
};

/**
* | output |
* | --- |
* | "Insured Name" |
*
* @param {Wallet_Card_Insured_NameInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const wallet_card_insured_name = /** @type {((inputs?: Wallet_Card_Insured_NameInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wallet_Card_Insured_NameInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wallet_card_insured_name(inputs)
	return fr_wallet_card_insured_name(inputs)
});